<template>
  <div class="home" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="blue"></div>
    <div class="Homemap"></div>
    <div class="homepage">
      <div class="header">
        <div class="headerImg">
          <div class="headerFont">
            <!-- 组件 -->
            <jinanNav class="jinanNav"></jinanNav>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="homemenu">
          <div class="leftFont">
            <ul>
              <!-- <img src="@/assets/img/paifeng/风机检测.jpg" alt="" v-if="hoverImg1" /> -->
              <!-- @mousemove="move1(index)" @mouseout="leave" -->
              <li v-for="(item, index) in leftList" :key="index" style=" cursor: pointer;" @click="gopage1(index)" id="fonts">
                <div class="leftContent">
                  <div class="chinese">{{ item.chinese }}</div>
                  <div class="english">{{ item.english }}</div>
                  <template v-if="hoverImg1 && index == 1">
                    <div class="content1">
                      <img class="img" src="@/assets/img/paifeng/风机检测.jpg" alt="" />
                      <!-- <div class="top">前往后台</div> -->
                      <!-- <div class="botoom"><i class="el-icon-right"></i></div> -->
                    </div>
                  </template>
                </div>
                <div class="rightContent">
                  <img :src="item.img" alt="" />
                </div>
              </li>
            </ul>
          </div>
          <div class="rightFont">
            <ul>
              <!-- @mousemove="move2(idx)" @mouseout="leave"   -->
              <li v-for="(it, idx) in leftRight" :key="idx" style=" cursor: pointer;" @click="gopage2(idx)" id="fonts">
                <div class="leftContent">
                  <div class="chinese">{{ it.chinese }}</div>
                  <div class="english">{{ it.english }}</div>
                  <template v-if="hoverImg2 && idx == 0">
                    <div class="content2">
                      <img class="img" src="@/assets/img/paifeng/风机检测.jpg" alt="" />
                      <!-- <div class="top">前往后台</div> -->
                      <!-- <div class="botoom"><i class="el-icon-back"></i></div> -->
                    </div>
                  </template>
                  <template v-if="hoverImg3 && idx == 1">
                    <div class="content3">
                      <img class="img" src="@/assets/img/paifeng/fan.gif" alt="" />
                      <!-- <div class="top">前往后台</div> -->
                      <!-- <div class="botoom"><i class="el-icon-back"></i></div> -->
                    </div>
                  </template>

                  <template v-if="hoverImg4 && idx == 2">
                    <div class="content4">
                      <img class="img" src="@/assets/img/paifeng/风机检测.jpg" alt="" />
                      <!-- <div class="top">前往后台</div> -->
                      <!-- <div class="botoom"><i class="el-icon-back"></i></div> -->
                    </div>
                  </template>
                </div>
                <div class="rightContent">
                  <img :src="it.img" alt="" />
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!-- <div class="guang"></div> -->
        <div class="yuan">
          <div class="map">
            <centerMap></centerMap>
          </div>
          <div class="bian">
            <div class="left_bian"></div>
            <div class="right_bian"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import jinanNav from '../../components/jinanNav.vue';
import centerMap from './components/center-map.vue';
// D:\同人建筑防火\wulian_vue\src\utils\rem.js
import '@/utils/rem.js';

// import { throttle } from "@/utils/rem.js";
export default {
  components: { jinanNav, centerMap },
  data() {
    return {
      leftList: [
        { chinese: '物联监控平台', english: 'IOT monitoring platform', img: require('@/assets/img/左1logo.png') },
        { chinese: '智能维保系统', english: 'Intelligent maintenan cemanagement', img: require('@/assets/img/左3logo.png') },
        { chinese: '物业消防管理', english: 'Property fire management', img: require('@/assets/img/左2logo.png') },
      ],
      leftRight: [
        { chinese: '消防设施检测', english: 'Fire fighting facilities detection', img: require('@/assets/img/右1logo.png') },
        { chinese: '单位消防评估', english: 'Fire evaluation', img: require('@/assets/img/右2logo.png') },
        { chinese: '工程消防验收', english: 'Fire acceptance', img: require('@/assets/img/右3logo.png') },
      ],
      hoverImg1: false,
      hoverImg2: false,
      hoverImg3: false,
      hoverImg4: false,
      nameList: [],
      type: 3,
      fullscreenLoading: false,
      info: {},
    };
  },
  created() {
    this.selfAdaption();
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    // left
    gopage1(index) {
      if (index == 0) {
        this.$router.push('/');
      } else if (index == 1) {
        this.$router.push('/score/detail?c_num=93fe79c642aa44e182aa3c793dfc9b55&name=凯贝特大厦&type=2');
      } else if (index == 2) {
        this.$router.push('/safe/safe-record');
      }
    },
    // right
    gopage2(idx) {
      if (idx == 0) {
        this.$router.push('/score/detail?c_num=93fe79c642aa44e182aa3c793dfc9b55&name=凯贝特大厦&type=5');
      } else if (idx == 1) {
        window.open('https://xcxht.tongren119.com/#/homepage?foreignToken=SUFoWFF2Q2pGWmFhUnJjSVhXNjFqamNBNG1BUEtGQ0JvbGFQS2t3STd0QT0');
      } else if (idx == 2) {
        window.open('https://xcxht.tongren119.com/#/homepage?foreignToken=SUFoWFF2Q2pGWmFhUnJjSVhXNjFqamNBNG1BUEtGQ0JvbGFQS2t3STd0QT0');
      }
    },
    move1(index) {
      // log(index);
      if (index == 1) {
        this.hoverImg1 = true;
      }
    },
    move2(idx) {
      if (idx == 0) {
        this.hoverImg2 = true;
      } else if (idx == 1) {
        this.hoverImg3 = true;
      } else if (idx == 2) {
        this.hoverImg4 = true;
      }
    },
    leave() {
      this.hoverImg1 = false;
      this.hoverImg2 = false;
      this.hoverImg3 = false;
      this.hoverImg4 = false;
    },
    getInfo() {
      // this.$store.dispatch("GetInfo").then((res) => {
      this.fullscreenLoading = false;
      const loading = this.$loading({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout(() => {
        loading.close();
      }, 600);
      // });
    },
    selfAdaption() {
      this.windowHeight = document.documentElement.clientHeight;
      this.windowWidth = document.documentElement.clientWidth;
      let heightScale = this.windowHeight / 1080;
      let widthScale = this.windowWidth / 1920;
      $('body').css({
        transform: `scale(${widthScale},${heightScale})`,
        '-ms-transform': `scale(${widthScale},${heightScale})`,
        '-webkit-transform': `scale(${widthScale},${heightScale})`,
      });
      window.onresize = () => {
        //屏幕尺寸改变时触发
        this.windowHeight = document.documentElement.clientHeight;
        this.windowWidth = document.documentElement.clientWidth;
        let heightScale = this.windowHeight / 1080;
        let widthScale = this.windowWidth / 1920;
        $('body').css({
          transform: `scale(${widthScale},${heightScale})`,
          '-ms-transform': `scale(${widthScale},${heightScale})`,
          '-webkit-transform': `scale(${widthScale},${heightScale})`,
        });
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.img {
  width: 140px;
  height: 140px;
}
.home {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background: url('~@/assets/newimg/homeBackground.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  background-blend-mode: color-dodge;
  .blue {
    width: 100%;
    height: 100%;
    background-color: #03315663;
    z-index: 99;
  }
  .Homemap {
    width: 90%;
    height: 90%;
    background: url('~@/assets/newimg/地图.png');
    background-repeat: no-repeat;
    background-blend-mode: lighten;
    background-size: cover;
    z-index: 100;
    opacity: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .homepage {
    z-index: 101;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    .header {
      width: 100%;
      height: 15%;
      // background-color: chocolate;
      .headerImg {
        min-width: 100%;
        height: 8.125rem;
        background-image: url('~@/assets/newimg/homeHead1.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .headerFont {
          width: 100%;
          height: 77%;
          .jinanNav {
            margin-left: 65px;
            position: relative;
            bottom: 8px;
          }
          // background-color: rgba(0, 255, 255, 0.292);
        }
      }
    }
    .section {
      width: 100%;
      height: 85%;
      // background-color: darkolivegreen;
      .homemenu {
        width: 100%;
        height: 31.25rem;
        background-image: url('~@/assets/newimg/Homemenu.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        .leftFont {
          position: absolute;
          top: 0.3125rem;
          left: 9.0625rem;
          color: #fff;
          display: flex;
          align-items: center;
          li:nth-child(1) {
            margin: -0.1875rem -10px;
            width: 25rem;
            height: 9.1875rem;
            // background-color: #7db987;
            display: flex;
            .leftContent {
              width: 300px;
              height: 100%;
              // background-color: #1d8cb5;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              line-height: 1.5;
              .chinese {
                font-weight: bolder;
                color: white;
                font-size: 30px;
                letter-spacing: 10.38px;
              }
              .english {
                font-weight: lighter;
                color: white;
                font-size: 20px;
              }
            }
            .rightContent {
              // background-color: #fff;
              width: 6.25rem;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          li:nth-child(2) {
            margin: 2.0625rem -75px;
            width: 28.125rem;
            height: 9.1875rem;
            // background-color: #7db987;
            display: flex;
            .leftContent {
              width: 21.875rem;
              height: 100%;
              // background-color: #1d8cb5;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              line-height: 1.5;
              .chinese {
                font-weight: bolder;
                color: white;
                font-size: 30px;
                letter-spacing: 10.38px;
              }
              .english {
                font-weight: lighter;
                color: white;
                font-size: 1.25rem;
              }
            }
            .rightContent {
              // background-color: #fff;
              width: 6.25rem;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          li:nth-child(3) {
            margin: -0.5rem -21px;
            width: 25rem;
            height: 9.1875rem;
            // background-color: #7db987;
            display: flex;
            .leftContent {
              width: 18.75rem;
              height: 100%;
              // background-color: #1d8cb5;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              line-height: 1.5;
              .chinese {
                font-weight: bolder;
                color: white;
                font-size: 30px;
                letter-spacing: 10.38px;
              }
              .english {
                font-weight: lighter;
                color: white;
                font-size: 20px;
              }
            }
            .rightContent {
              // background-color: #fff;
              width: 6.25rem;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          .content1 {
            width: 200px;
            height: 150px;
            position: absolute;
            top: 35.5%;
            // flex-direction: column;
            left: 13.555rem;
            display: flex;
            align-items: center;
            justify-content: space-evenly;
            .top {
              width: 3.875rem;
              // background-color: #106396;
              font-weight: bolder;
            }
            .botoom {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-color: #fff;

              color: #000;

              text-align: center;
              line-height: 20px;
            }
          }
        }
        .rightFont {
          color: #fff;
          position: absolute;
          right: 0;
          top: 0;
          display: flex;
          align-items: center;

          li:nth-child(1) {
            margin: 2px 70px;
            width: 25rem;
            height: 9.1875rem;
            // background-color: #7db987;
            display: flex;
            flex-direction: row-reverse;
            .leftContent {
              width: 332px;
              height: 100%;
              // background-color: #1d8cb5;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              line-height: 1.5;
              .chinese {
                font-weight: bolder;
                color: white;
                font-size: 30px;
                letter-spacing: 10.38px;
              }
              .english {
                font-weight: lighter;
                color: white;
                font-size: 20px;
              }
            }
            .rightContent {
              // background-color: #fff;
              width: 100px;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          li:nth-child(2) {
            margin: 33px 100px;
            width: 25rem;
            height: 9.1875rem;
            display: flex;
            flex-direction: row-reverse;
            .leftContent {
              width: 18.75rem;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              line-height: 1.5;
              .chinese {
                font-weight: bolder;
                color: white;
                font-size: 30px;
                letter-spacing: 10.3808px;
              }
              .english {
                font-weight: lighter;
                color: white;
                font-size: 20px;
              }
            }
            .rightContent {
              width: 6.25rem;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          li:nth-child(3) {
            margin: -8px 70px;
            width: 25rem;
            height: 9.1875rem;
            display: flex;
            flex-direction: row-reverse;
            .leftContent {
              width: 18.75rem;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              line-height: 1.5;
              .chinese {
                font-weight: bolder;
                color: white;
                font-size: 30px;
                letter-spacing: 10.38px;
              }
              .english {
                font-weight: lighter;
                color: white;
                font-size: 20px;
              }
            }
            .rightContent {
              // background-color: #fff;
              width: 100px;
              height: 100%;
              display: flex;
              align-items: center;
            }
          }
          .content2 {
            width: 200px;
            height: 150px;
            position: absolute;
            top: 0%;
            left: 15px;
            display: flex;
            align-items: center;
            flex-direction: row-reverse;
            justify-content: space-evenly;
            .top {
              width: 3.875rem;
              // background-color: #106396;
              font-weight: bolder;
            }
            .botoom {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-color: #fff;

              color: #000;

              text-align: center;
              line-height: 20px;
            }
          }
          .content3 {
            width: 200px;
            height: 150px;
            position: absolute;
            top: 35.5%;
            // flex-direction: column;
            left: 50px;
            display: flex;
            align-items: center;
            flex-direction: row-reverse;
            justify-content: space-evenly;
            .top {
              width: 3.875rem;
              // background-color: #106396;
              font-weight: bolder;
            }
            .botoom {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-color: #fff;

              color: #000;

              text-align: center;
              line-height: 20px;
            }
          }
          .content4 {
            width: 200px;
            height: 150px;
            position: absolute;
            top: 71%;
            // flex-direction: column;
            left: 20px;
            display: flex;
            align-items: center;
            flex-direction: row-reverse;
            justify-content: space-evenly;
            .top {
              width: 3.875rem;
              // background-color: #106396;
              font-weight: bolder;
            }
            .botoom {
              width: 20px;
              height: 20px;
              border-radius: 50%;
              background-color: #fff;
              color: #000;
              text-align: center;
              line-height: 20px;
            }
          }
        }
      }
      // .guang {
      //   width: 100%;
      //   height: 500px;
      //   background-image: url("~@/assets/newimg/99.png");
      //   background-repeat: no-repeat;
      //   z-index: 999 !important;
      //   opacity: 1;
      // }
      .yuan {
        width: 43.875rem;
        height: 35.1875rem;
        border-radius: 50%;
        position: absolute;
        top: 55%;
        left: 50%;
        transform: translate(-50%, -50%);
        background-color: #0b2552ad;
        .bian {
          z-index: 102;
          position: absolute;
          top: 0%;
          left: 0%;
          // 边
          .left_bian {
            width: 7.1875rem;
            height: 20.25rem;
            background: url('~@/assets/img/组 1.png') no-repeat center;
            background-size: 100% 100%;
            background-size: cover;
            // z-index: 99;
            position: absolute;
            top: 8.1875rem;
            left: 0;
          }
          .right_bian {
            background: url('~@/assets/img/组 1.png') no-repeat center;
            width: 7.1875rem;
            height: 20.25rem;
            background-size: cover;
            background-size: 100% 100%;
            // z-index: 99;
            position: absolute;
            top: 8.1875rem;
            left: 36.555rem;
            transform: rotate(185deg);
          }
        }
      }
    }
    .map {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 42%;
      left: 48%;
      transform: translate(-50%, -50%);
      z-index: 200;
    }
  }
}
</style>
